export const OverViewInput = [
  {
    label: "Day Number",
    id: "daynumber",
    valueKey: "day",
    placeholder: "Day Number",
    defaultValue: "Day Number not found",
  },
  {
    label: "Day Name",
    id: "dayname",
    valueKey: "day_name",
    placeholder: "Day Name",
    defaultValue: "Day Name not found",
  },
  {
    label: "Workout Duration",
    id: "workoutduration",
    valueKey: "estimated_duration",
    placeholder: "Workout Duration",
    defaultValue: "Workout Duration not found",
  },
];
